import * as UI from "@iyk/ui"

// The Open Graph protocol: https://ogp.me

// #region Constants

const BASE_URL = "https://iyk.app"

const DEFAULT_IMAGE_URL = "https://assets.iyk.app/iyk/consumer/og-image.png"

const DEFAULT_DESCRIPTION = "Build your digi-physical wwworld with IYK"

// #endregion

// #region Functions

function isSupportedImage(url: string) {
  return Object.values(UI.acceptImagesFileType.accept)
    .flatMap((ext) => ext)
    .some((ext) => url.endsWith(ext))
}

function getImageUrl(imageUrl: OpenGraphMetadata["imageUrl"]) {
  return imageUrl && isSupportedImage(imageUrl) ? imageUrl : DEFAULT_IMAGE_URL
}

function getTypeSpecificProperties(metadata: OpenGraphMetadata): OpenGraphProperty[] {
  switch (metadata.type) {
    case "profile":
      return [{ property: "profile:username", content: metadata.username }]
    case "website":
      return []
  }
}

/** Generate the Open Graph properties for a given metadata */
export function generateProperties(metadata: OpenGraphMetadata): OpenGraphProperty[] {
  return [
    { property: "og:title", content: metadata.title },
    { property: "og:image", content: getImageUrl(metadata.imageUrl) },
    {
      property: "og:description",
      content: metadata.description ?? DEFAULT_DESCRIPTION,
    },
    { property: "og:url", content: `${BASE_URL}${metadata.pathname}` },
    { property: "og:type", content: metadata.type },
    ...getTypeSpecificProperties(metadata),
  ]
}

// #endregion

// #region Types

type BaseMetadata = {
  title: string
  pathname: string
  imageUrl?: string | null
  description?: string | null
}

type ProfileMetadata = BaseMetadata & {
  type: "profile"
  username: string
}

type WebsiteMetadata = BaseMetadata & {
  type: "website"
}

type OpenGraphMetadata = ProfileMetadata | WebsiteMetadata

type OpenGraphProperty = {
  property: string
  content: string
}

// #endregion
